import { render } from "./PopupDialog.vue?vue&type=template&id=19637d72"
import script from "./PopupDialog.vue?vue&type=script&lang=js"
export * from "./PopupDialog.vue?vue&type=script&lang=js"

import "./PopupDialog.vue?vue&type=style&index=0&id=19637d72&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__